
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "../components/Layout";
import { Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import { useIsMobile, withDeviceType } from "../lib/media";
import TextWithImg from "../components/TextWithImg";
import HeroLanding from "../components/landings/HeroLanding";
import StepsGroup from "../components/landings/StepsGroup";
import HowToSteps from "../components/landings/HowToSteps";
import Headline from "../components/common/Headline";
import { pushRoute } from "../lib/routing";
interface Props {
    deviceType?: string;
}
function VeterinaryCover(props: Props) {
    const { deviceType } = props;
    const { t } = useTranslation("veterinarycover");
    const isMobileViewport = useIsMobile(deviceType);
    // Images
    const imgCover = "/images/landings/veterinarycover_header_desktop.webp";
    const imgDesc = "/images/landings/veterinarycover_description.webp";
    const imgBeforeClaim = "/images/landings/veterinarycover_before_claim.webp";
    // For the check lists
    const infoLeft = {
        title: t("veterinarycover:coveringClaimsTitle"),
        infoList: [...Array(5)].map((_, i) => t(`veterinarycover:check${i + 1}`)),
        icon: "check",
        color: "successGreen"
    };
    const infoRight = {
        title: t("veterinarycover:nonCoveringClaimsTitle"),
        infoList: [...Array(9)].map((_, i) => t(`veterinarycover:negativeCheck${i + 1}`)),
        icon: "x",
        color: "errorRed"
    };
    const onButtonClick = () => {
        pushRoute({ pathname: "/search" });
    };
    return (<Layout withTransparentHeader title={t("veterinarycover:pageName")} displayFooterAreas withHrefLang>
      <HeroLanding isMobileViewport={isMobileViewport} imgsrc={imgCover} title={t("title")} button={{ text: t("start"), onSubmit: onButtonClick }} width={{ mobile: "75%", nonMobile: "30%" }} imgAlt={t("veterinarycover:pageName")}/>

      <Headline variant="veterinarycover" title={t("veterinarycover:titleDesc")}/>

      <TextWithImg imgsrc={imgDesc} imgAlt={t("veterinarycover:explanation")} imgRight>
        <Text as="p" variant={"textWithImg.text"}>
          {t("veterinarycover:explanation")}
        </Text>
      </TextWithImg>

      <StepsGroup variant="veterinarycover" infoLeft={infoLeft} infoRight={infoRight}/>

      <TextWithImg title={t("veterinarycover:noticeTitle")} imgsrc={imgBeforeClaim} imgAlt={t("veterinarycover:noticeTitle")} imgLeft>
        <Text as="p" variant={"textWithImg.text"}>
          {t("veterinarycover:noticeDescription")}
        </Text>
      </TextWithImg>

      <HowToSteps isMobileViewport={isMobileViewport} variant="veterinarycover" numSteps={3}/>
    </Layout>);
}
const getServerSideProps = withDeviceType()();
export default VeterinaryCover;

    async function __Next_Translate__getServerSideProps__1987f3f231e__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/veterinarycover',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1987f3f231e__ as getServerSideProps }
  